/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D3dInputs */

const en_mk_sol_ukm_d3d = /** @type {(inputs: Mk_Sol_Ukm_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The issue is created once, assigned to the Marketing agent, and the caption draft is ready long before Sunday night.`)
};

const id_mk_sol_ukm_d3d = /** @type {(inputs: Mk_Sol_Ukm_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue dibuat sekali, di-assign ke agen Marketing, dan draf captionnya siap jauh sebelum Minggu malam.`)
};

/**
* | output |
* | --- |
* | "The issue is created once, assigned to the Marketing agent, and the caption draft is ready long before Sunday night." |
*
* @param {Mk_Sol_Ukm_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d3d = /** @type {((inputs?: Mk_Sol_Ukm_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d3d(inputs)
	return en_mk_sol_ukm_d3d(inputs)
});